import React from "react";
import HomePage from "../components/home/HomePage";
import generateConfig from "../util/config";

const config = generateConfig();

export default function Home() {
  return <HomePage />;
}

export async function getServerSideProps() {
  const metaTags = {
    title: `Experienced FullStack Developer | ${
      config.siteName || "Krushna Raut"
    }`,
    description:
      "Experienced full-stack developer crafting premium web experiences with React, TypeScript, motion, and conversational interfaces. Explore product highlights, case studies, and AI experiments.",
    keywords:
      "Krushna Raut, experienced full-stack developer, React developer, TypeScript expert, product designer, portfolio",
    img: "/social-card.svg",
  };
  return {
    props: {
      metaTags,
    },
  };
}
